/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDomainSearch = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M10.523 2.108C5.7 2.822 2 6.98 2 12c0 5.523 4.477 10 10 10 .488 0 .968-.035 1.438-.103A5.976 5.976 0 0 1 12 18c0-1.537.578-2.938 1.528-4H13v-4h2.766l.038.222c.111.69.172 1.404.17 2.129A5.984 5.984 0 0 1 17.97 12a15.165 15.165 0 0 0-.177-2h1.955a8.016 8.016 0 0 1 .245 2.339 5.996 5.996 0 0 1 1.904 1.099c.068-.47.103-.95.103-1.438 0-5.523-4.477-10-10-10-.5 0-.994.036-1.475.107zM4.252 10h1.93a14.724 14.724 0 0 0-.08 4h-1.85a8.047 8.047 0 0 1 0-4zm.818-2a8.04 8.04 0 0 1 2.682-2.78c-.44.82-.827 1.76-1.125 2.78zM11 4.185V8H8.724c.251-.74.553-1.414.88-2 .48-.857.975-1.459 1.396-1.815zM11 10v4H8.119a12.642 12.642 0 0 1 .09-4zm0 6v3.938l-.02-.002A10.678 10.678 0 0 1 8.594 16zm-3.403 2.68A8.04 8.04 0 0 1 5.07 16H6.5c.254.905.613 1.805 1.097 2.68zM17.348 8c-.3-1.03-.693-1.978-1.137-2.803A8.04 8.04 0 0 1 18.93 8zM13 4.206c.415.359.901.954 1.37 1.794.328.586.63 1.26.881 2H13z" />
        <path d="M18 14a4 4 0 1 0 2.03 7.448l2.263 2.26 1.413-1.416-2.261-2.257A4 4 0 0 0 18 14zm-2 4a2 2 0 1 1 4 0 2 2 0 0 1-4 0z" />
      </g>
    </g>
  </Icon>
);
export { SvgDomainSearch as DomainSearch };
